import type { ErpModule } from '@/api/platform.api';
import { getModuleEntryByErpModule } from '@/config/moduleEntries';
import { isPlatformAdminRoute } from '@/config/moduleDefaults';
import { isGlobalWorkspaceRoute } from '@/constants/globalWorkspaceRoutes';

/** API `module` query — omit on cross-module org admin and global work routes. */
export function resolveNotificationModuleParam(
  pathname: string,
  activeModule: ErpModule | null,
): ErpModule | undefined {
  if (isPlatformAdminRoute(pathname)) return undefined;
  if (isGlobalWorkspaceRoute(pathname)) return undefined;
  return activeModule ?? undefined;
}

export function notificationPanelTitle(module: ErpModule | undefined): string {
  if (!module) return 'Notifications';
  const label = getModuleEntryByErpModule(module)?.label ?? module;
  return `${label} notifications`;
}
